import './Header.css';
import React from 'react';

const Header = () => {
    return (
        <nav>
            <h1>BD-Watch-Shop</h1>
            <h2>Select 4 Watches </h2>
        </nav>
    );
};

export default Header;